export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9897.38a05d69.jpg";